import React, { useCallback, useEffect, useState } from "react";
import { Card, CardHeader, CardContent, Button, Typography, TableContainer, Table,  TableHead, TableRow, TableCell, TableBody, Chip, IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useNavigate } from "react-router-dom";
import api from "../api/api";
import Loading from "../components/loading";
import SuccessMessage from "../components/successMessage";
import ErrorMessage from "../components/errorMessage";
import NotificationModal from "./notificationsModal";

export default function NotificationsList() {
    
    const navigate = useNavigate();

    const [isLoading, setLoading] = useState(false);
    const [notifications, setNotifications] = useState([]);
    
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const getNotifications = useCallback(() => {
        setLoading(true);
        api.get('/notifications', { 
            headers: { Authorization: sessionStorage.getItem('token') }
        }).then((response) => {
            setNotifications(response.data);
        }).catch((error) => {
            console.error("ops! ocorreu um erro", error);
            if (error.response?.status === 401) {
                navigate("/expired-session");
            } else {
                setShowErrorMessage(true);
                setErrorMessage("Não foi possível carregar as notificações.");
            }
        }).finally(() => {
            setLoading(false);
        });
    }, [navigate]);

    useEffect(() => {
        getNotifications();
    }, [getNotifications]);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

   const onNotificationSaveSuccess = (returnFromApi) => {
        setShowSuccessMessage(true);
        setSuccessMessage(returnFromApi.data.message || returnFromApi.data || "Notificação salva!"); 
        closeModal();
        getNotifications(); 
    };

    const getStatusColor = (status) => {
        if (status === 'SENT') return 'success';
        if (status === 'PENDING') return 'warning';
        if (status === 'FAILED') return 'error';
        return 'default';
    };

    return (
        <>
            <Loading isToHidden={!isLoading} />
            {showSuccessMessage && <SuccessMessage message={successMessage} show={showSuccessMessage} setShow={setShowSuccessMessage} />}
            {showErrorMessage && <ErrorMessage message={errorMessage} show={showErrorMessage} setShow={setShowErrorMessage} />}

            <Card variant="outlined" sx={{ borderRadius: 2 }}>
                <CardHeader
                    title={<Typography variant="h5" sx={{ fontWeight: 'bold' }}>Notificações</Typography>}
                    action={
                        <Button variant="outlined" onClick={openModal}>
                            Adicionar Notificação
                        </Button>
                    }
                />
                <CardContent>
                    {!isLoading && notifications.length === 0 ? (
                        <Typography align="center" sx={{ py: 4 }}>
                            Nenhuma notificação cadastrada.
                        </Typography>
                    ) : (
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Data</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Título</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Destinatário</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                                        <TableCell></TableCell> 
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {notifications.map((notification) => (
                                        <TableRow key={notification.id} hover>
                                            <TableCell width="15%">
                                                {new Date(notification.createdAt).toLocaleDateString('pt-BR')}
                                            </TableCell>
                                            <TableCell width="30%">{notification.title}</TableCell>
                                            <TableCell width="25%">{notification.recipient}</TableCell>
                                            <TableCell width="15%">
                                                <Chip
                                                    label={notification.status}
                                                    color={getStatusColor(notification.status)}
                                                    size="small"
                                                />
                                            </TableCell>
                                            <TableCell align="right">
                                                <IconButton size="small">
                                                    <MoreVertIcon fontSize="small" />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </CardContent>
            </Card>

            <NotificationModal
                open={isModalOpen}
                onClose={closeModal}
                onSaveSuccess={onNotificationSaveSuccess} 
            />
        </>
    );
}